(() => {
  "use strict";

  const SELECTORS = {
    section: "[data-athletes-section]",
    slider: "[data-athletes-slider]",
    dots: "[data-athletes-dots]",
  };

  const DOT_CLASSES = {
    active: "size-6 flex items-center justify-center before:size-2 before:rounded-full before:transition-colors before:bg-primary",
    inactive: "size-6 flex items-center justify-center before:size-2 before:rounded-full before:transition-colors before:bg-disabled",
  };

  const waitForEmbla = () =>
    new Promise((resolve) => {
      const check = () => {
        if (typeof EmblaCarousel !== "undefined") {
          resolve();
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });

  const createDot = (index, isActive) => {
    const dot = document.createElement("button");
    dot.className = isActive ? DOT_CLASSES.active : DOT_CLASSES.inactive;
    dot.setAttribute("role", "tab");
    dot.setAttribute("aria-selected", String(isActive));
    dot.setAttribute("aria-label", `Slide ${index + 1}`);
    dot.dataset.dotIndex = index;
    return dot;
  };

  const updateDots = (dotsContainer, selectedIndex) => {
    dotsContainer.querySelectorAll("button").forEach((dot, i) => {
      const isActive = i === selectedIndex;
      dot.setAttribute(
        "class",
        isActive ? DOT_CLASSES.active : DOT_CLASSES.inactive,
      );
      dot.setAttribute("aria-selected", String(isActive));
    });
  };

  const renderDots = (embla, dotsContainer) => {
    const scrollSnaps = embla.scrollSnapList();
    dotsContainer.replaceChildren();

    scrollSnaps.forEach((_, index) => {
      const dot = createDot(index, index === embla.selectedScrollSnap());
      dot.addEventListener("click", () => embla.scrollTo(index));
      dotsContainer.appendChild(dot);
    });
  };

  const initializeSection = async (section) => {
    const sliderNode = section.querySelector(SELECTORS.slider);
    const dotsContainer = section.querySelector(SELECTORS.dots);

    if (!sliderNode) return;

    await waitForEmbla();

    const embla = EmblaCarousel(sliderNode, {
      loop: false,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps",
    });

    if (dotsContainer) {
      renderDots(embla, dotsContainer);

      embla.on("select", () =>
        updateDots(dotsContainer, embla.selectedScrollSnap()),
      );

      embla.on("reInit", () => renderDots(embla, dotsContainer));
    }
  };

  const init = () => {
    document.querySelectorAll(SELECTORS.section).forEach(initializeSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
 